import { render, staticRenderFns } from "./OrdersHome.vue?vue&type=template&id=318d9b5a&scoped=true&"
import script from "./OrdersHome.vue?vue&type=script&lang=js&"
export * from "./OrdersHome.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHome.vue?vue&type=style&index=0&id=318d9b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d9b5a",
  null
  
)

export default component.exports